import React, { FC, useCallback, useEffect, useState } from 'react';
import type { Editor } from '@tiptap/react';
import { Badge, Button, Col, Dropdown, Input, Row } from 'antd';
import { TbCircleXFilled, TbExternalLink, TbLink, TbTrash, TbWorld } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { DropdownMenuPanel } from '@/shared';

interface AddLinkDropdownProps {
    editor: Editor;
}

const AddLinkDropdown: FC<AddLinkDropdownProps> = ({ editor }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setURL(editor?.getAttributes('link').href);
        setLoading(false);
    }, []);

    const [url, setURL] = useState(editor?.getAttributes('link').href);

    const setLink = useCallback(() => {
        const previousUrl = editor?.getAttributes('link').href;

        setURL(previousUrl);

        // const url = window.prompt('URL', previousUrl);

        // cancelled
        if (url === null) {
            return;
        }

        // // empty
        if (url === '') {
            editor?.chain().focus().extendMarkRange('link').unsetLink().run();

            return;
        }

        // update link
        editor?.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
    }, [editor]);

    const { token } = useAntDesignTheme();

    return (
        <Dropdown
            placement='bottomRight'
            trigger={['click']}
            popupRender={() => (
                <DropdownMenuPanel style={{ padding: 0 }}>
                    <Row>
                        <Col flex='auto'>
                            <Input
                                value={url}
                                onChange={(e) => setURL(e.target.value)}
                                prefix={
                                    editor?.getAttributes('link').href ? (
                                        <TbExternalLink
                                            size='1rem'
                                            style={{
                                                cursor: 'pointer',
                                                color: token.colorTextTertiary,
                                                marginRight: '0.5rem',
                                            }}
                                            onClick={() => {
                                                window.open(editor?.getAttributes('link').href);
                                            }}
                                        />
                                    ) : (
                                        <TbWorld
                                            size='1rem'
                                            style={{ color: token.colorTextQuaternary, marginRight: '0.5rem' }}
                                        />
                                    )
                                }
                                placeholder='URL...'
                                allowClear={{
                                    clearIcon: <TbCircleXFilled size='1rem' style={{ verticalAlign: '-0.25rem' }} />,
                                }}
                                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                addonAfter={
                                    editor?.getAttributes('link').href &&
                                    url === editor?.getAttributes('link').href && (
                                        <>
                                            <TbTrash
                                                size='1rem'
                                                style={{ cursor: 'pointer', verticalAlign: '-0.175rem' }}
                                                onClick={() => {
                                                    // cancelled
                                                    if (url === null) {
                                                        return;
                                                    }

                                                    // // empty
                                                    if (url === '') {
                                                        editor
                                                            ?.chain()
                                                            .focus()
                                                            .extendMarkRange('link')
                                                            .unsetLink()
                                                            .run();

                                                        setURL('');

                                                        return;
                                                    }

                                                    editor?.chain().focus().extendMarkRange('link').unsetLink().run();

                                                    setURL('');

                                                    return;
                                                }}
                                            />
                                        </>
                                    )
                                }
                            />
                        </Col>
                        <Col flex='none'>
                            {(!editor?.getAttributes('link').href ||
                                (url !== '' && url !== editor?.getAttributes('link').href)) && (
                                <Button
                                    disabled={!url}
                                    type={'primary'}
                                    style={{ borderLeft: 'none' }}
                                    onClick={() => {
                                        editor?.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
                                    }}
                                >
                                    Save
                                </Button>
                            )}
                        </Col>
                    </Row>
                    {/* {results?.length !== 0 && !loading ? (
                        results?.map((r: any) => {
                            return (
                                <Menu.Item key="asdf">
                                    <TbWorld
                                        size="1rem"
                                        style={{ verticalAlign: '-0.175rem', marginRight: '0.25rem' }}
                                    />
                                    https://google.com
                                    <br />
                                    <small style={{ color: token.colorTextTertiary }}>https://google.com</small>
                                </Menu.Item>
                            );
                        })
                    ) : loading ? (
                        <SkeletonList listLength={4} />
                    ) : (
                        <div style={{ height: '5rem', ...centerComponentInMiddleofView }}>No Items</div>
                    )} */}
                </DropdownMenuPanel>
            )}
        >
            <Button
                className={editor.isActive('bold') ? 'is-active' : ''}
                icon={
                    <Badge
                        count={' '}
                        showZero
                        color='blue'
                        size='small'
                        style={{
                            display: editor?.getAttributes('link').href ? undefined : 'none',
                            boxShadow: 'none',
                            border: `0.2rem solid ${token.colorBgBase}`,
                        }}
                        offset={[-2, 14]}
                    >
                        <TbLink size='1rem' style={{ verticalAlign: '-0.125rem' }} />
                    </Badge>
                }
                style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderRightColor: 'transparent',
                }}
                type='text'
            />
        </Dropdown>
    );
};

export default AddLinkDropdown;
